<template>
  <div class="stage">
    <VideoBanner v-if='$route.name === "Stage Rental"' posterSrc='scen.jpg' mp4Src='scen.mp4' webmSrc='scen.webm' :overlayTitle='$COMPANY.NAME' :overlayDescription='$COMPANY.DESCRIPTION' />
    <div class="main-content small-content">
      <b-container>
        <h2>Scenteknik &amp; uthyrning</h2>
        <div class="stage-content page-content">
          <b-row>
            <b-col>
              <h3>Skräddarsydda tekniska lösningar för ditt event</h3>
              <p>Oavsett om du planerar en intim tillställning, en stor konferens eller en spektakulär konsert, erbjuder vi den utrustning och expertis som krävs för att ditt evenemang ska bli en succé. Vi tillhandahåller allt från ljud, ljus och scenutrustning till full teknisk support.</p>
              <h3>Allt för ditt event - en helhetslösning</h3>
              <p>Tillsammans med våra pålitliga leverantörer erbjuder vi en komplett teknisk lösning för alla typer av evenemang: konserter, mässor, företagsevenemang, privata fester och mycket mer. Vi ser till att rätt utrustning är på plats och att tekniken fungerar smidigt.</p>
              <h3>Kvalitet och pålitlighet</h3>
              <p>Vi vet hur viktigt det är att tekniken fungerar utan problem. Därför levererar vi endast högkvalitativa produkter och expertstöd, oavsett storlek på ditt event. Ljud, ljus och scenlösningar som skapar rätt stämning och lyfter din upplevelse.</p>
              <h3>Stöd genom hela processen</h3>
              <p>Från planering till genomförande, vi finns med dig för att säkerställa att all teknik fungerar som den ska. Vi hanterar den tekniska delen så att du kan fokusera på att skapa minnesvärda upplevelser för dina gäster.</p>
              <p class="last-pop">Kontakta oss för att boka tekniken till ditt nästa event!</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import VideoBanner from './VideoBanner'

export default {
  components: {
    VideoBanner
  }
}
</script>

<style>

</style>
